<template>
<section>
    <div v-if="loading" class="content content-centered">
        <pulse-loader></pulse-loader>
    </div>
    <div v-if="isShowLogo">
        <h1>Showing logo</h1>
        <img width="400" height="300" src="{{" city.cityLogo }} />
        </div>
    
        <div v-show=" !loading" class="content">
        <div class="box">
            <div class="box-body">
                <div class="row">
                    <div class="flash-message col-md-4 col-md-offset-4 text-center" v-if="flash">
                        <div class="alert" :class="'alert-' + flashType">
                            {{ flashMessage }}
                        </div>
                    </div>
                </div>
                <div class="collection_location_scroll">
                <div id="details" class="row collection_location_inner">
                    <vue-form :state="formstate" @submit.prevent="onSubmit" class="row">
                        <div class="col-sm-12">
                            <div class="col-sm-6">
                                <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.cityName)">
                                    <label>City</label>
                                    <input type="text" maxlength="25" name="cityName" class="form-control" required v-model="city.cityName" placeholder="City Name" pattern="^[a-zA-Z]([a-zA-Z\s!@#]{0,24}[a-zA-Z])*$" />
                                    <field-messages name="cityName" show="$touched || $submitted" class="form-control-feedback">
                                        <div slot="required">City Name is a required field</div>
                                        <div slot="pattern">
                                            Alphabets/Numbers are allowed.
                                        </div>
                                    </field-messages>
                                </validate>
                            </div>

                            <div class="col-sm-6">
                                <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.firstName)">
                                    <label> Admin First Name</label>
                                    <input type="text" name="firstName" class="form-control" required v-model="city.firstName" @input= "capitalizeFirstName()" placeholder="City Admin First Name" pattern="^[a-zA-Z]([a-zA-Z\s!@#]{0,24}[a-zA-Z])*$" />
                                    <field-messages name="firstName" show="$touched || $submitted" class="form-control-feedback">
                                        <div slot="required">
                                            Admin First Name is a required field
                                        </div>
                                        <div slot="pattern">
                                            Alphabets are allowed and upto 25 characters.
                                        </div>
                                    </field-messages>
                                </validate>
                            </div>
                        </div>
                        <div class="col-sm-12">
                            <div class="col-sm-6">
                                <validate auto-label class="form-group" :class="fieldClassName(formstate.lastName)">
                                    <label> Admin Last Name</label>
                                    <input type="text" name="lastName" class="form-control" @input="capitalizeLastName()" v-model="city.lastName" placeholder="City Admin Last Name" pattern="^[a-zA-Z]([a-zA-Z\s!@#]{0,24}[a-zA-Z])*$" />
                                    <field-messages name="lastName" show="$touched || $submitted" class="form-control-feedback">
                                        <div slot="pattern">
                                            Alphabets are allowed and upto 25 characters.
                                        </div>
                                    </field-messages>
                                </validate>
                            </div>
                            <div class="col-sm-6">
                                <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.email)" :custom="{ email: emailValidator }">
                                    <label>Email</label>
                                    <input required v-model="city.email" type="email" class="form-control" name="email" placeholder="Email" />
                                    <field-messages name="email" show="$touched || $submitted" class="form-control-feedback">
                                        <div slot="required">This is required field</div>
                                        <div slot="email">Email Id is invalid</div>
                                    </field-messages>
                                </validate>
                            </div>
                        </div>
                        <div class="col-sm-12">
                            <div class="col-sm-6">
                                <validate auto-label class="form-group" :class="fieldClassName(formstate.document1)">
                                    <label>User ID Proof 1</label>
                                    <input type="file" accept="image/png,image/jpeg,image/jpg,application/pdf" id="fileinput" @change="onDocumentchanged1" class="form-control" required name="proof_1" />
                                    <field-messages name="proof_1" show="$touched || $submitted" class="form-control-feedback">
                                        <div slot="required">
                                            Please upload less than 3mb picture
                                        </div>
                                    </field-messages>
                                    <div class="border p-2 mt-3" v-if="
                            $route.params &&
                              $route.params._id != '0' &&
                              city.licenceFront
                          ">
                                        <a v-bind:href="city.licenceFront" target="_blank">
                                            View
                                        </a>
                                    </div>
                                </validate>
                            </div>

                            <div class="col-sm-6">
                                <validate auto-label class="form-group" :class="fieldClassName(formstate.document)">
                                    <label>User ID Proof 2</label>
                                    <input type="file" accept="image/png,image/jpeg,image/jpg,application/pdf" id="fileinput1" name="proof_2" class="form-control" @change="onDocumentchanged2" />
                                    <field-messages name="proof_2" show="$touched || $submitted" class="form-control-feedback">
                                        <div slot="required">
                                            Please upload less than 3mb document
                                        </div>
                                    </field-messages>
                                    <div class="border p-2 mt-3" v-if="
                            $route.params &&
                              $route.params._id != '0' &&
                              city.licenceBack
                          ">
                                        <a v-bind:href="city.licenceBack" target="_blank">
                                            View
                                        </a>
                                    </div>
                                </validate>
                            </div>
                        </div>
                        <div class="col-sm-12">
                            <div class="col-sm-6">
                                <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.mobile)">
                                    <label>Contact Number</label>
                                    <input required v-model="city.mobile" type="string" maxlength="10" class="form-control" name="mobile" placeholder="Contact" pattern="[78965][0-9]{9}" />
                                    <field-messages name="mobile" show="$touched || $submitted" class="form-control-feedback">
                                        <div slot="required">This is required field</div>
                                        <div slot="pattern">Numbers are allowed.</div>
                                    </field-messages>
                                </validate>
                            </div>
                        </div>
                    </vue-form>
                    <!-- v-permission.if="[USER_ROLES.ADMIN,USER_ROLES.SUPER_ADMIN,USER_ROLES.GA_HEAD,USER_ROLES.JOURNEY_MANAGER]" -->
                    <div class="col-sm-12 text-right">
                        <router-link :to="{ name: 'city' }">
                            <button class="mr-5 btn btn-default" type="button">
                                Cancel
                            </button>
                        </router-link>
                        <button class="mr-2 btn gradientbt" type="submit" @click="createCity" :disabled="!(formstate.$dirty && formstate.$valid)" v-if="$route.params && $route.params._id == '0'">
                            Save
                        </button>

                        <button class="btn gradientbt mr-5" type="submit" @click="updateCity" :disabled="
                      !((formstate.$dirty || isFileChange) && formstate.$valid)
                    " v-if="$route.params && $route.params._id != '0'">
                            Update
                        </button>
                    </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</section>
</template>

    
    
<script>
import axios from "axios";
import {
    formService,
    cityService,
    fileService
} from "../../../services";
import {
    EVENTS
} from "../../../config";
import {
    USER_ROLES
} from "../../../config";

export default {
    name: "addCity",
    data() {
        return {
            isFileChange: false,
            isShowLogo: false,
            ready: false,
            USER_ROLES: USER_ROLES,
            loading: false,
            flash: false,
            flashType: null,
            flashMessage: "",
            EVENTS: EVENTS,
            formstate: {},
            region_list: {},
            city: {
                status: "true",
            },
            oldCity: {},
            cityId: [],
            docs: null,
        };
    },
    // mounted: function() {
    //     this.getRegionList()
    // },
    methods: {
        fieldClassName: formService.fieldClassName,
        emailValidator: formService.emailValidator,
        capitalizeFirstLetter(word) {
            return word.charAt(0).toUpperCase() + word.slice(1);
        },
        capitalizeFirstName() {
         
                this.city.firstName = this.capitalizeFirstLetter(this.city.firstName);

        },
        capitalizeLastName() {
                this.city.lastName = this.capitalizeFirstLetter(this.city.lastName);
        },
        onDocumentchanged1(event) {
            this.docs1 = event.target.files[0];
            this.city.licenceFront = event.target.files[0]["name"];
        },
        onDocumentchanged2(event) {
            this.docs2 = event.target.files[0];
            this.city.licenceBack = event.target.files[0]["name"];
        },

        showLogo() {
            this.isShowLogo = !this.isShowLogo;
        },
        getCity() {
            return cityService
                .getById(this.$route.params._id)
                .then((response) => {
                    this.city = {
                        cityName: response.data.cityName,
                        firstName: response.data.user.firstName,
                        lastName: response.data.user.lastName,
                        email: response.data.user.email,
                        mobile: response.data.user.mobile + "",
                        status: response.data.status,
                        licenceFront: response.data.user.licenceFront,
                        licenceBack: response.data.user.licenceBack,
                    };
                    this.oldCity = _.cloneDeep(this.city);
                    this.$store.dispatch("setBreadcrumbTitle", this.city.cityName);
                })
                .catch((error) => {
                    this.$snotify.error("Get city failed", "Error!");
                });
        },
        onDocumentchanged(event) {
            this.docs = event.target.files[0];
        },

        async uploadDocument() {
            let docsArr = [];
            docsArr.push(this.docs);
            const response = await fileService.fileUpload(docsArr, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });
            return response.data;
        },

        // async uploadDocument() {
        //     // let formData = new FormData();
        //     if ( this.docs ) {
        //         // formData.append('file', this.docs);
        //         const response = await fileService.fileUpload(this.docs, {
        //             headers: {
        //                 'Content-Type': 'multipart/form-data',
        //             },
        //          })
        //          if(response.data.length > 0){
        //             return response.data[0]["Location"]
        //          }
        //          return "";
        //     }else {
        //         return "";
        //     }
        //     // formData.append('model', 'city');
        //     // formData.append('docId', docId);
        //     // axios
        //     //     .post('fileUpload', formData, {
        //     //         headers: {
        //     //             'Content-Type': 'multipart/form-data',
        //     //         },
        //     //     })
        //     //     .then(res => {
        //     //         this.$router.push('/city');
        //     //     })
        //     //     .catch(function () {
        //     //     });

        // },

        async createCity() {
            this.loading = true;
            if (this.docs != null) {
                let uploadedFileLocation = await this.uploadDocument();
                if (uploadedFileLocation !== "") {
                    this.city.cityLogo = uploadedFileLocation[0].Location;
                }
            }

            if (this.docs1 != null) {
                let uploadedFileLocation = await this.uploadDocument1();
                if (uploadedFileLocation !== "") {
                    this.city["licenceFront"] = uploadedFileLocation[0].Location;
                }
            }
            if (this.docs2 != null) {
                let uploadedFileLocation = await this.uploadDocument2();
                if (uploadedFileLocation !== "") {
                    this.city["licenceBack"] = uploadedFileLocation[0].Location;
                }
            }

            return cityService
                .addCity(this.city)
                .then((response) => {
                    this.loading = false;
                    this.flash = false;
                    this.$snotify.success(
                        `The ${this.city.cityName} has been added successfully.`
                    );
                    this.$router.push("/city");
                })
                .catch((error) => {
                    this.loading = false;
                    if (error.data && error.data.message) {
                        this.$snotify.error(error.data.message, "Error!");
                    } else {
                        this.$snotify.error("City Update Failed.", "Error!");
                    }
                });
        },

        clearChanges() {
            this.city = _.cloneDeep(this.oldCity);
            this.formstate._reset();
        },
        async updateCity() {
            this.loading = true;
            this.city.cityId = this.$route.params._id;
            this.city["mobile"] = this.city["mobile"] + "";

            if (this.docs1 != null) {
                let uploadedFileLocation = await this.uploadDocument1();
                if (uploadedFileLocation !== "") {
                    this.city["licenceFront"] = uploadedFileLocation[0].Location;
                }
            }
            if (this.docs2 != null) {
                let uploadedFileLocation = await this.uploadDocument2();
                if (uploadedFileLocation !== "") {
                    this.city["licenceBack"] = uploadedFileLocation[0].Location;
                }
            }
            if (this.city.licenceFront == null) {
                delete this.city.licenceFront;
            }
            if (this.city.licenceBack == null) {
                delete this.city.licenceBack;
            }

            return cityService
                .updateCity(this.city, this.oldCity)
                .then((response) => {
                    this.loading = false;
                    this.flash = false;
                    this.formstate._reset();
                    this.oldCity = _.cloneDeep(this.city);
                    this.$snotify.success(
                        `The ${this.city.cityName}  has been updated successfully.`
                    );
                    this.$router.push("/city");
                })
                .catch((error) => {
                    this.loading = false;
                    // if (error.data.status == 409) {
                    //     var errorMessage = "Mobile Already Exist!";
                    //     this.$snotify.error(errorMessage, "Error!");
                    // }
                    // else if (error.data.message == "CityName Already Exist!!") {
                    //     var errorMessage = "CityName Already Exist!";
                    //     this.$snotify.error(errorMessage, "Error!");
                    // }
                    // else (error.data.message == "Email Already Exist!!") {
                    //     var errorMessage = "Email Already Exist!";
                    //     this.$snotify.error(errorMessage, "Error!");
                    // }
                    if (error.data && error.data.message) {
                        this.$snotify.error(error.data.message, "Error!");
                    } else {
                        this.$snotify.error("City Update Failed.", "Error!");
                    }
                });
        },
        onDocumentchanged1(event) {
            const fileinput = document.getElementById("fileinput");
            if (
                ["image/png", "image/jpeg", "image/jpg", "application/pdf"].includes(
                    event.target.files[0]["type"]
                )
            ) {
                if (event.target.files[0].size > 1024 * 1024 * 1) {
                    this.$snotify.error("File Size max limit of 1 MB", "Error!");
                    fileinput.value = "";
                    event.preventDefault();
                    return;
                } else {
                    this.docs1 = event.target.files[0];
                    if (this.docs1) {
                        this.isFileChange = true;
                    } else {
                        this.isFileChange = false;
                    }
                }
            } else {
                this.$snotify.error("Upload .png, .jpeg, .jpg, .pdf files", "Error!");
                fileinput.value = "";
            }
        },
        onDocumentchanged2(event) {
            const fileinput = document.getElementById("fileinput1");
            if (
                ["image/png", "image/jpeg", "image/jpg", "application/pdf"].includes(
                    event.target.files[0]["type"]
                )
            ) {
                if (event.target.files[0].size > 1024 * 1024 * 1) {
                    this.$snotify.error("File Size max limit of 1 MB", "Error!");
                    fileinput.value = "";
                    event.preventDefault();
                    return;
                } else {
                    this.docs2 = event.target.files[0];
                    if (this.docs2) {
                        this.isFileChange = true;
                    } else {
                        this.isFileChange = false;
                    }
                }
            } else {
                this.$snotify.error("Upload .png, .jpeg, .jpg, .pdf files", "Error!");
                fileinput.value = "";
            }
        },

        async uploadDocument1() {
            let docsArr = [];
            docsArr.push(this.docs1);
            const response = await fileService.fileUpload(docsArr, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });
            return response.data;
        },
        async uploadDocument2() {
            let docsArr = [];
            docsArr.push(this.docs2);
            const response = await fileService.fileUpload(docsArr, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });
            return response.data;
        },
    },
    created() {
        const promises = [];
        this.loading = true;
        if (
            this.$route.params &&
            this.$route.params._id &&
            this.$route.params._id != "0"
        ) {
            promises.push(this.getCity());
        }
        Promise.all(promises)
            .then(() => {
                this.loading = false;
                this.ready = true;
            })
            .catch((error) => {
                this.loading = false;
                this.$snotify.error("City create error", "Error!");
            });
    },
    beforeDestroy() {},
    fieldClassName: function (field) {
        if (!field) {
            return "";
        }
        if ((field.$touched || field.$submitted) && field.$valid) {
            return "has-success";
        }
        if ((field.$touched || field.$submitted) && field.$invalid) {
            return "has-danger";
        }
    },

    // computed: {
    //     ...mapState({
    //         user: state => state.auth.user,
    //     })
    // }
};
</script>
    
    
<style scoped>
.required-field>label::after {
    content: "*";
    color: red;
    margin-left: 0.25rem;
}

.form-control-feedback {
    font-weight: 100;
    color: red;
    position: initial;
    text-align: left;
    height: auto;
    width: auto;
}

.has-danger {
    color: red;
}

.mt {
    margin-top: 7px;
}

.gradientbt {
    color: white;
    background: #0f6940;
}

.input-box {
    display: flex;
    align-items: center;
    /* max-width: 300px; */
    background: #fff;
    border: 1px solid #a0a0a0;
    border-radius: 4px;
    padding-left: 0.5rem;
    overflow: hidden;
    font-family: sans-serif;
}

.input-box .prefix {
    font-weight: bold;
    font-size: 16px;
}

.input-box input {
    flex-grow: 1;
    font-size: 16px;
    background: #fff;
    border: none;
    outline: none;
    padding: 0.5rem;
}

.input-box:focus-within {
    border-color: #777;
}
</style>



// WEBPACK FOOTER //
// addCity.vue?6d51a4d2